/**
 * created by yxy
 工具栏修改图片
 *
 */
import React, {Component} from 'react';
import {Card, Input, InputNumber, message, Modal, Switch, Tooltip} from "antd";
import {buildInsertPicHtml} from "../../../toolsSpace/tools/pictureTool/pictureTool"
import TaskPicture from "../../../../Interview/components/btn/TaskPicture";
import {uuid} from "../../../../../utils"
import leftSideIcon from "../../image/leftside.png";
import leftCenterIcon from "../../image/leftCenter.png";
import rightCenterIcon from "../../image/rightCenter.png";
import centerIcon from "../../image/center.png";
import $Jq from "jquery";
import $ from "jquery";
import BaseComponent from "../../../../../base/BaseComponent";
import {buildInsertVideoHtml} from "../../../toolsSpace/tools/videoTool/videoTool";

export default class InterviewTaskVideo extends BaseComponent {
    constructor(props) {
        super(props);
        this.state = {
            cssWidth: this.sysConfigGetValueByKey("editor.content.video.insert.width", "500"),
            cssHeight: 0,
            cssAutoPlay: eval(this.sysConfigGetValueByKey("editor.content.video.insert.autoplay", "false")),
            fileList: [],
            previewVisible:false,
            float: null,
            videoMaxSize: this.sysConfigGetValueByKey("Upload.max.videoSize", "500")*1,
        };

    }
    componentDidMount() {
        if (this.urlParams) {
            let taskId = this.urlParams.taskId;
            this.setIds({taskId});
        }
    }
    setIds = ({taskId}) => {
        this.state.taskId = taskId;
        this.setState({taskId: taskId})
    };


    onOk = () => {
        let {float,cssWidth,cssHeight,cssAutoPlay,array} = this.state;
        console.log(float,cssWidth,cssHeight,cssAutoPlay,'float,cssWidth,cssHeight,cssAutoPlay')
        let newArray = [];
        let {checkData} = this.state;
        checkData && checkData.length && checkData.forEach((item, index) => {
            if(item.checked){
                newArray.push(item)
            }
        });
        let videoHTML = '';
        newArray && newArray.map(file => {
            array.map(item=>{
                if(item.id === file.id){
                    file.duration = item.extendedAttributeJson.duration
                }
            })
            file.playUrl = file.thumbnailsPlayPath?file.thumbnailsPlayPath:file.icon;
            file.url = file.thumbnailsPath?file.thumbnailsPath:file.path;
            videoHTML += buildInsertVideoHtml({
                ...file,
                float:float,
                originalWith:file.width,
                originalHeight:file.height,
                width:cssWidth?parseInt(cssWidth):null,
                height: cssHeight?parseInt(cssHeight):null,
                autoplay: cssAutoPlay,
                videoPic:file.thumbnailsPlayPath,
                duration:file.duration
            });
        });
        let isSuccess = true;
        if(videoHTML){
            isSuccess = this.props.editor.rmtExecCommand("inserthtml", videoHTML);
        }
        if(isSuccess) {
            this.onClose();
        }
    };
    onClose = () => {
        if (typeof this.props.onCloseCall === 'function') {
            this.props.onCloseCall()
        }
        this.setState({visible: false})
    };

    showModal = () => {
        this.setState({
            visible: true
        })
    };

    imageLabelId = "a_" + uuid();

    render() {
        let baseStyle = {marginLeft: 15, cursor: "pointer"};
        let defaultStyle = {...baseStyle, border: "1px solid #FFF"};
        let defaultWidth = 500;
        let defaultWaterPic = this.state.waterPicList && this.state.waterPicList.find(water => water.status === 1);
        if (!defaultWaterPic) {
            this.state.cssWater = false;
        }
        let checkedStyle = {
            ...baseStyle,
            borderTop: "solid 1px #000",
            borderLeft: "solid 1px #000",
            borderRight: "solid 1px #DCDCDC",
            borderBottom: "solid 1px #DCDCDC"
        };
        return (
            <div >
                <Modal
                    title={this.props.title}
                    visible={this.state.visible}
                    maskClosable={false}
                    width={800}
                    className={'InterviewTaskVideo'}
                    onCancel={this.onClose}
                    onOk={this.onOk}
                >
                    <div>
                        <div style={{
                            display: 'flex',
                            justifyContent: "end",
                            borderBottom: '1px solid  rgba(0, 0, 0, 0.06)',
                            paddingBottom:'16px',
                        }}>
                            <div>
                                浮动方式：
                                <Tooltip title={"无浮动"} onClick={() => {
                                    this.setState({float: null})
                                }}><img style={this.state.float === null ? checkedStyle : defaultStyle}
                                        src={leftSideIcon}/></Tooltip>
                                <Tooltip title={"左浮动"} onClick={() => {
                                    this.setState({float: "left"})
                                }}><img style={this.state.float === "left" ? checkedStyle : defaultStyle}
                                        src={leftCenterIcon}/></Tooltip>
                                <Tooltip title={"右浮动"} onClick={() => {
                                    this.setState({float: "right"})
                                }}><img style={this.state.float === "right" ? checkedStyle : defaultStyle}
                                        src={rightCenterIcon}/></Tooltip>
                                <Tooltip title={"居中独占一行"} onClick={() => {
                                    this.setState({float: "center"})
                                }}><img style={this.state.float === "center" ? checkedStyle : defaultStyle}
                                        src={centerIcon}/></Tooltip>
                            </div>
                        </div>

                        <TaskPicture id={this.state.taskId} showCheck={true} current={'3'} callBack={(data) => {this.setState({checkData: data})
                        }} callBackArray={(array)=>{this.setState({array})}}></TaskPicture>
                        <table style={{marginBottom:10}} width={"100%"} cellSpacing={0} cellPadding={0} border={0}><tbody><tr>
                            <td  width={140} colSpan={6}>
                                <div className="seat">
                                    <span>宽度（px）</span>
                                    <InputNumber min={1} max={100000} defaultValue={parseInt(this.state.cssWidth)} onChange={(value)=>{this.inputNumberOnChange(value, 'cssWidth')}} />
                                    <span style={{marginLeft: 10}}>高度（px）</span>
                                    <InputNumber min={0} max={100000} defaultValue={0} onChange={(value)=>{this.inputNumberOnChange(value, 'cssHeight')}} />
                                </div>
                            </td>

                            <td width={140}>
                                <div className="watermark">
                                    <span style={{marginRight:10}}>自动播放设置</span>
                                    <Switch checkedChildren="开" unCheckedChildren="关" defaultChecked={this.state.cssAutoPlay} onChange={(value)=>{this.inputNumberOnChange(value, 'cssAutoPlay')}}/>
                                </div>
                            </td>
                        </tr></tbody></table>
                    </div>
                </Modal>

                <style>{
                    `.InterviewTaskVideo .ant-modal-body{padding-bottom:0;padding-top:16px}`
                }</style>
            </div>
        )
    }

    inputNumberOnChange(value, type = 'width') {
        this.state[type] = value;
        this.setState({});
    }

}